import LocalPoliceIcon from '@mui/icons-material/LocalPolice';
import SettingsIcon from '@mui/icons-material/Settings';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import StorefrontIcon from '@mui/icons-material/Storefront';
import EventIcon from '@mui/icons-material/Event';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import PeopleIcon from '@mui/icons-material/People';
import AssessmentIcon from '@mui/icons-material/Assessment';
import FeedIcon from '@mui/icons-material/Feed';
// import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import PersonIcon from '@mui/icons-material/Person';

import { t } from 'i18n/index';

const studentNavLinks = [
  { id: "memberships", text: t('literal:memberships'), Icon: LocalPoliceIcon, link: '/profile' },
  { id: "tickets", text: t('literal:tickets'), Icon: LocalActivityIcon, link: '/tickets' },
  { id: "merch", text: 'Merch', Icon: StorefrontIcon, link: '/merch' },
  { id: "orders", text: t('literal:billingHistory'), Icon: ShoppingBasketIcon, link: '/orders' },
  { id: "settings", text: t('literal:preferences'), Icon: SettingsIcon, link: '/settings/details' },
];

// export const getNavLinks = (context, organizationId) => {
  export const getNavLinks = (context) => {
  if (context === "teacher") {
    return getTeacherNavLinks();
  } else {
    return studentNavLinks;
 }
};

// export const getTeacherNavLinks = (organizationId) => {
  export const getTeacherNavLinks = () => {
  const navLinks =
  [
    { id: 'profile', text: 'Club Profile', Icon: PersonIcon, link: 'profile' },
    { id: 'events', text: 'Events', Icon: EventIcon, link: 'events' },
    { id: 'content', text: 'Newsletter', Icon: FeedIcon, link: 'content' },
    { id: 'perks', text: 'Store', Icon: StorefrontIcon, link: 'perks' },
    { id: 'memberships', text: 'Memberships', Icon: ConfirmationNumberIcon, link: `memberships` },
    { id: 'community', text: 'Community', Icon: PeopleIcon, link: 'community' },
    { id: 'analytics', text: 'Reports & Analytics', Icon: AssessmentIcon, link: 'analytics/visits' },
    { id: 'settings', text: 'Settings', Icon: SettingsIcon, link: 'settings/email' },
    // { id: 'collectibles', text: 'Collectibles', Icon: LocalPoliceIcon, link: collectiblesLink },
  ]

  return navLinks;
} ;
